import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function Contact() {
  const { t } = useTranslation();
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // ovdje kasnije možeš spojiti backend / email
    e.target.reset();
    setSent(true);
    setTimeout(() => setSent(false), 4000);
  };

  return (
    <section id="contact" className="section section-alt">
      <div className="container">
        <div style={{ textAlign: "center" }}>
          <h2>{t("contact.sectionTitle")}</h2>
          <p className="section-subtitle">{t("contact.sectionSubtitle")}</p>
          <div style={{ marginTop: "2rem", fontSize: "1rem", color: "#9ca3af" }}>
            <div style={{ marginBottom: "0.5rem" }}>📞 +385 91 214 4477</div>
            <div>✉️ info@travelina.hr</div>
          </div>
        </div>
        {/* Forma zakomentirana dok se ne postavi email
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="field">
            <label>{t("contact.name")}</label>
            <input type="text" required />
          </div>
          <div className="field">
            <label>{t("contact.email")}</label>
            <input type="email" required />
          </div>
          <div className="field">
            <label>{t("contact.destination")}</label>
            <input type="text" />
          </div>
          <div className="field-row">
            <div className="field">
              <label>{t("contact.month")}</label>
              <input type="month" />
            </div>
            <div className="field">
              <label>{t("contact.people")}</label>
              <input type="number" min="1" max="20" />
            </div>
          </div>
          <div className="field">
            <label>{t("contact.message")}</label>
            <textarea rows="4" />
          </div>
          <button className="btn primary" type="submit">
            {t("contact.btnSend")}
          </button>
          {sent && <p className="form-success">{t("contact.success")}</p>}
        </form>
        */}
      </div>
    </section>
  );
}
